import { render, staticRenderFns } from "./PDFgeneratorReceipt.vue?vue&type=template&id=6f3b105b"
import script from "./PDFgeneratorReceipt.vue?vue&type=script&lang=js"
export * from "./PDFgeneratorReceipt.vue?vue&type=script&lang=js"
import style0 from "./PDFgeneratorReceipt.vue?vue&type=style&index=0&id=6f3b105b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports